import React, { Component } from "react";
import {
  profile,
  alert,
  float,
  toFixed,
  GET,
  POST,
  PUT,
  loading,
  required,
  Select,
  Navbar,
  Modal,
} from "../../components/CustomComponent.js";
import { NumericFormat } from "react-number-format";
import RANK1 from "../../assets/images/rank/rank1.png";
import RANK2 from "../../assets/images/rank/rank2.png";
import RANK3 from "../../assets/images/rank/rank3.png";
import RANK4 from "../../assets/images/rank/rank4.png";
import RANK5 from "../../assets/images/rank/rank5.png";
import RANK6 from "../../assets/images/rank/rank6.png";

const RANK_IMAGES = { 1: RANK1, 2: RANK2, 3: RANK3, 4: RANK4, 5: RANK5, 6: RANK6 };
export default class Tiers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      filter_search: "",

      data: [],
      loaded: false,
      count: 10,
      data_broker: [],
      data_sequence: [],

      id: "",
      uid: "",
      broker_id: "",
      sequence: "",
      tier_name: "",
      min_gmv: "",
      currency: "",
      description: "",

      deposit_fee_type: "",
      deposit_fee_value: "",
      deposits_commission_type: "",
      deposits_commission_value: "",

      withdrawal_fee_type: "",
      withdrawal_fee_value: "",
      withdrawal_commission_type: "",
      withdrawal_commission_value: "",

      text_th: "",
      text_en: "",
    };
  }

  async componentDidMount() {
    let check = [
      {name: "Thuntachon Acting Sub Lt. Tirayut",bank_name:"THIRAYUT TANTHACHON MR."}
    ]


    // console.clear();
    // let index = 0;
    // const result = await this.validate(check[index].name, check[index].bank_name, 70);
    // console.log(result);
    // console.log(check[index].name , ":" ,check[index].bank_name);

    // let array = [];
    // for (let c of check) {
    //   const result = await this.validate(c.name, c.bank_name, 70);
    //   try {
    //     if (result.score !== 100) {
    //       array.push(c);
    //     }
    //   } catch (e) {}
    // }
    // console.log(array);

    loading(false);
    await Promise.all([this.GetMaster(), this.Get()]);
  }
  // ตัวเลือกของ dropdown ทั้งหน้า ไม่เปลี่ยนระหว่างอยู่บนหน้านี้ ดึงครั้งเดียวตอนเปิดหน้า
  // ไม่ยุ่งกับ loading เพราะ Get เป็นคนคุมสถานะโหลดของตาราง
  GetMaster = async () => {
    let data_broker = [];
    let [result_broker] = await Promise.all([
      GET("v1/admin/brokers/options", {
        page_size: 100000,
        page: 0,
        data_search: "",
      }),
    ]);
    if (result_broker?.status) {
      data_broker = result_broker.data.map((e) => ({
        value: e.uid,
        label: e.name_en,
        gateway: e.gateway_deposits,
      }));
    }
    this.setState({ data_broker });
  };
  Get = async () => {
    let data = [],
      data_sequence = [];
    loading(true);
    let [result] = await Promise.all([
      GET("v1/admin/tier-configs/list", {
        data_search: this.state.filter_search,
        page_size: 100000,
        page: 0,
      }),
    ]);
    if (result?.status) {
      result.data
        .sort((a, b) => a.sequence - b.sequence)
        .sort((a, b) => a.tier_name - b.tier_name);
      for (let item of result.data) {
        let index = data.findIndex((e) => e.broker_id === item.broker?.uid);
        if (index === -1) {
          data.push({ broker_id: item.broker?.uid, array: [item] });
        } else {
          data[index].array.push(item);
        }
      }
    }
    if (data.length > 0) {
      data_sequence = [
        ...new Set(
          data
            .reduce(
              (a, b) => (b.array?.length > a.array?.length ? b : a),
              data[0]
            )
            .array?.map((e) => e.sequence)
        ),
      ];
    }
    this.setState({
      data,
      data_sequence,
      loaded: true,
    });
    loading(false);
  };
  CreateUpdate = async () => {
    const {
      uid,
      broker_id,
      sequence,
      tier_name,
      min_gmv,
      currency,
      description,

      deposit_fee_type,
      deposit_fee_value,
      deposits_commission_type,
      deposits_commission_value,

      withdrawal_fee_type,
      withdrawal_fee_value,
      withdrawal_commission_type,
      withdrawal_commission_value,
    } = this.state;
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the submission?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);
      let body = {
        broker_id,
        sequence,
        tier_name,
        min_gmv: Number(min_gmv),
        currency,
        description,

        deposit_fee_type,
        deposit_fee_value: Number(deposit_fee_value),
        deposits_commission_type,
        deposits_commission_value: Number(deposits_commission_value),

        withdrawal_fee_type,
        withdrawal_fee_value: Number(withdrawal_fee_value),
        withdrawal_commission_type,
        withdrawal_commission_value: Number(withdrawal_commission_value),
      };

      let result = !uid
        ? await POST("tier-configs/create", body)
        : await PUT("tier-configs/update/" + uid, body);
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again."
        );
      }
      loading(false);
    }
  };

  async validate(name, bank_name, threshold = 70) {
    function similarity(nameA, nameB, wordThreshold = 70) {
      if (!nameA || !nameB) return 0;

      const normalize = (str) =>
        str
          .toLowerCase()
          .normalize("NFC")
          .replace(/\b(mr|mrs|miss|ms)\b/g, "")
          .replace(/kh/g, "k")
          .replace(/ph/g, "p")
          .replace(/th/g, "t")
          .replace(/ch/g, "j")
          .replace(/ee/g, "e")
          .replace(/[^a-z0-9\u0E00-\u0E7F ]/gi, "")
          .replace(/\s+/g, " ")
          .trim();

      const aWords = normalize(nameA).split(" ").filter(Boolean);
      const bWords = normalize(nameB).split(" ").filter(Boolean);

      if (!aWords.length || !bWords.length) return 0;

      const levenshtein = (a, b) => {
        const dp = Array(b.length + 1)
          .fill(0)
          .map((_, i) => i);

        for (let i = 1; i <= a.length; i++) {
          let prev = i;
          for (let j = 1; j <= b.length; j++) {
            const cur =
              a[i - 1] === b[j - 1]
                ? dp[j - 1]
                : Math.min(dp[j - 1], prev, dp[j]) + 1;
            dp[j - 1] = prev;
            prev = cur;
          }
          dp[b.length] = prev;
        }

        return 1 - dp[b.length] / Math.max(a.length, b.length);
      };

      let matched = 0;

      for (const aw of aWords) {
        let best = 0;
        for (const bw of bWords) {
          best = Math.max(best, levenshtein(aw, bw));
        }
        if (best * 100 >= wordThreshold) matched++;
      }

      return Math.round(
        (matched / Math.max(aWords.length, bWords.length)) * 100
      );
    }
    function log(score, name_lang, name, bank_name_lang, bank_name) {
      if (score === 100) {
        console.warn(
          score.toFixed(2).toString(),
          " :: ",
          name_lang,
          ":",
          name,
          " :: ",
          bank_name_lang,
          ":",
          bank_name
        );
      } else {
        console.log(
          score.toFixed(2).toString(),
          " :: ",
          name_lang,
          ":",
          name,
          " :: ",
          bank_name_lang,
          ":",
          bank_name
        );
      }
    }
    async function checkMismatch( thaiName, engName, threshold = 70, count = 0, check = false ) {
      const map = {
        ก: ["kka", "kho", "kha", "kh", "ka", "ca", "ck", "ko", "ke", "kr", "kl", "kk", "k", "c", "g"],
        ข: ["kka", "kho", "kha", "kh", "ka", "ca", "ck", "ko", "ke", "kr", "kl", "kk", "k", "c", "g"],
        ฃ: ["kka", "kho", "kha", "kh", "ka", "ca", "ck", "ko", "ke", "kr", "kl", "kk", "k", "c", "g"],
        ค: ["kka", "kho", "kha", "kh", "ka", "ca", "ck", "ko", "ke", "kr", "kl", "kk", "k", "c", "g"],
        ฅ: ["kka", "kho", "kha", "kh", "ka", "ca", "ck", "ko", "ke", "kr", "kl", "kk", "k", "c", "g"],
        ฆ: ["kka", "kho", "kha", "kh", "ka", "ca", "ck", "ko", "ke", "kr", "kl", "kk", "k", "c", "g"],
        ง: ["ng", "nk", "n", "g", "k"],
        จ: ["tcha", "tja", "tta", "cha", "cho", "jha", "jho", "ch", "ja", "jo", "tt", "j", "z", "d", "t"],
        ฉ: ["tcha", "cha", "sha", "ch", "tch", "sh", "t"],
        ช: ["tcha", "tch", "cha", "sha", "cho", "tcha", "ch", "sh", "s", "t", "d", "j"],
        ซ: ["tcha", "tch", "cha", "sha", "so", "sh", "zh", "s", "z", "t", "d"],
        ฌ: ["ch", "sh"],
        ญ: ["nya", "ny", "ne", "ya", "y", "j", "n"],
        ฎ: ["tha", "th", "tt", "dt", "d", "t"],
        ฏ: ["tha", "th", "tt", "dt", "t", "d"],
        ฐ: ["ttars", "thta", "tars", "ttha", "tta", "tha", "tho", "ha", "ta", "to", "tt", "th", "t", "h", "d"],
        ฑ: ["ttars", "thta", "tars", "ttha", "tta", "tha", "tho", "ha", "ta", "to", "tt", "th", "t", "h", "d"],
        ฒ: ["ttars", "thta", "tars", "ttha", "tta", "tha", "tho", "ta", "to", "tt", "th", "t", "d"],
        ณ: ["nna", "na", "no", "nt", "rn", "ne", "n"],
        ด: ["dor", "da", "do", "d", "t"],
        ต: ["ttars", "thta", "tars", "ttha", "tta", "ta", "te", "to", "tt", "dt", "t"],
        ถ: ["ttars", "thta", "tars", "ttha", "tta", "tha", "tho", "ta", "to", "tt", "th", "ha", "dt", "dh", "t", "d"],
        ท: ["ttars", "thta", "tars", "ttha", "tta", "tha", "tho", "ta", "to", "tt", "th", "ha", "dt", "dh", "t", "d"],
        ธ: ["ttars", "thta", "tars", "ttha", "tta", "tha", "tho", "ta", "to", "tt", "th", "ha", "dt", "dh", "t", "h"],
        น: ["nor", "nar", "nna", "nta", "na", "no", "nt", "rn", "ne", "or", "n"],
        บ: ["bor", "bo", "ba", "b", "p"],
        ป: ["pha", "pa", "po", "p", "b"],
        ผ: ["pha", "pa", "po", "ph", "p", "f"],
        ฝ: ["ph", "fh", "fo", "f"],
        พ: ["pha", "pho", "pau", "pua", "ppa", "pa", "ph", "po", "p", "f", "b"],
        ฟ: ["ph", "fh", "fo", "f"],
        ภ: ["pha", "pho", "ph", "po", "pa", "p", "h"],
        ม: ["mma", "mm", "me", "ma", "mo", "m"],
        ย: ["ya", "yo", "ta", "y", "j", "i"],
        ร: ["rnra", "nra", "rai", "orn", "awn", "lar", "ra", "ro", "rn", "rh", "hn", "na", "la", "r", "n", "l", "a"],
        ล: ["nla", "lla", "la", "lo", "on", "ol", "re", "le", "l", "n", "r"],
        ว: ["wor", "war", "ua", "wa", "va", "wo", "vo", "w", "v", "o"],
        ศ: ["tsa", "ssa", "dsa", "ss", "sa", "so", "se", "te", "ts", "s", "t", "d"],
        ษ: ["tsa", "ssa", "dsa", "sh", "sa", "so", "se", "te", "ts", "s", "t", "d"],
        ส: ["tsa", "ssa", "dsa", "st", "sa", "so", "se", "te", "ts", "s", "t", "d"],
        ห: ["ha", "ho", "h"],
        ฬ: ["l", "la"],
        ฮ: ["wh", "ho", "h", "w"],
        อ: ["ao", "or", "a", "o", "r"],
        ฤ: ["ruea", "rueh", "ris", "rue", "roe", "reo", "rao", "roa", "ri", "ru", "re", "ua", "ue", "eu", "au", "i"],
        ฤา: ["rhae", "rha", "raa", "ra", "ua", "ue", "eu", "au"],
        ฦ: ["lue", "leu", "lu", "li"],
        ฦา: ["laa", "la"],

        ะ: ["a"],
        "ั": ["ant", "ai", "an", "un", "nt", "a", "u", "i", "n"],
        า: ["aa", "ar", "ro", "a", "o", "r"],
        "ิ": ["ear", "er", "ee", "ie", "ue", "i", "e", "r"],
        "ี": ["ee", "ie", "ia", "i", "e"],
        "ึ": ["ue", "ua", "au", "eu"],
        "ื": ["ue", "ua", "au", "eu"],
        "ุ": ["u", "oo", "o"],
        "ู": ["u", "oo", "o"],
        เ: ["eh", "ea", "ay", "e", "a", "y"],
        แ: ["ae", "ea", "a", "e"],
        โ: ["oh", "oa", "ou", "ro", "u", "o", "a"],
        ใ: ["ai", "ay", "i"],
        ไ: ["ai", "ay", "i"],
        ำ: ["ame", "ahm", "am", "me", "um", "om", "m"],
        "็": [""],
        "ํ": ["m"],
        "์": [""],
        ฯ: [""],
        " ": [" "],
        "": ["."],
        ไอ: ["ai", "ay", "i"],
        าย: ["ai", "ay"],
        รร: ["an", "ran", "ron"],
      };

      // เช็ค SCORE
      let score = similarity(thaiName, engName);
      if (score > threshold) {
        return { score: score, isMatch: true };
      }

      // Clean ภาษาไทย
      let cleanThaiName = thaiName;
      cleanThaiName = cleanThaiName
        .replace(/-|[่้็๋๊]/g, "")
        .replace(/[ก-๙][\u0E30-\u0E4E]*์/g, "")
        .replace(/([กขคจดตทธพบบปภมวสษศหอ])รร/g, "$1ั")
        .replace(
          /ัทร|ัตระ|หย|หร|หล/g,
          (m) => ({ "ัทร": "ัทระ", "ัตระ": "ัท", หย: "ย", หร: "ร", หล: "ล" }[m])
        )
        .replace(/([โไใแเ])(.)/g, "$2$1")
        .replaceAll(" ", "")
        .trim();

      // LOG
      if (check) {
        console.log("cleanThaiName:", ":::::", cleanThaiName, ":::::", engName);
      }

      engName = engName.replaceAll(" ", "");

      // เช็คความตรงของชื่อ
      let checkName = "";
      for (let i = 0; i < cleanThaiName.length; i++) {
        try {
          for (let item of map[cleanThaiName[i]]) {
            const e = engName.toLowerCase();
            const t = checkName + item;
            if (check) {
              console.log(
                "0:",
                cleanThaiName[i],
                "::",
                checkName + item,
                " - ",
                thaiName,
                " - ",
                engName
              );
              [1, 2, 3, 4, 5].forEach((n) => {
                const s = e.slice(0, checkName.length + n);
                (s === t ? console.warn : console.log)(
                  `${n}:`,
                  s,
                  "::",
                  s === t
                );
              });
            }
            if (
              e.slice(0, checkName.length + 1) === t ||
              e.slice(0, checkName.length + 2) === t ||
              e.slice(0, checkName.length + 3) === t ||
              e.slice(0, checkName.length + 4) === t ||
              e.slice(0, checkName.length + 5) === t
            ) {
              checkName = t;
              if (check) console.log("checkName:", checkName);
              break;
            }
          }
        } catch (e) {}
      }

      // เช็ค SCORE
      score = similarity(checkName, engName.toLowerCase());
      if (score > threshold) {
        return { score: score, isMatch: true };
      } else if (count === 1) {
        return { score: score, isMatch: false };
      } else {
        let result_switch = await checkMismatch(
          thaiName,
          engName.split(" ").reverse().join(" "),
          threshold,
          1,
          check
        );
        return result_switch;
      }
    }
    if (name.trim() === "" || bank_name.trim() === "") {
      return { score: 0, isMatch: false };
    }

    // ตัดคำข้างหน้า และ replace รูปแบบทั้งหมด
    const regx = /(^|\s)(mrs\.?|mr\.?|miss|mss\.|ms\.|m\.?s\.?|d\.?r\.?|prof|s\.|master|mister|rev\.|m\.?l\.?|m\.?r\.?|m\.?c\.?|M\.?L\.?|M\.?R\.?|M\.?C\.?|คุณ|ว่าที่|นาย|นางสาว|นาง|น\.?ส\.?|ด\.?ช\.?|ด\.?ญ\.?|พล\.?อ\.?|พล\.?ท\.?|พล\.?ต\.?|พ\.?อ\.?|พ\.?ท\.?|พ\.?ต\.?|ร\.?อ\.?|ร\.?ท\.?|ร\.?ต\.?|จ\.?ส\.?อ\.?|จ\.?ส\.?ท\.?|จ\.?ส\.?ต\.?|ส\.?อ\.?|ส\.?ท\.?|ส\.?ต\.?|พล\.?ร\.?อ\.?|พล\.?ร\.?ท\.?|พล\.?ร\.?ต\.?|น\.?อ\.? \.?\.?\.?ร\.?น\.?|น\.?ท\.? \.?\.?\.?ร\.?น\.?|น\.?ต\.? \.?\.?\.?ร\.?น\.?|ร\.?อ\.? \.?\.?\.?ร\.?น\.?|ร\.?ท\.? \.?\.?\.?ร\.?น\.?|ร\.?ต\.? \.?\.?\.?ร\.?น\.?|พ\.?จ\.?อ\.?|พ\.?จ\.?ท\.?|พ\.?จ\.?ต\.?|จ\.?อ\.?|จ\.?ท\.?|จ\.?ต\.?|พล\.?อ\.?อ\.?|พล\.?อ\.?ท\.?|พล\.?อ\.?ต\.?|น\.?อ\.?|น\.?ท\.?|น\.?ต\.?|ร\.?อ\.?|ร\.?ท\.?|ร\.?ต\.?|พ\.?อ\.?อ\.?|พ\.?อ\.?ท\.?|พ\.?อ\.?ต\.?|จ\.?อ\.?|จ\.?ท\.?|จ\.?ต\.?|พล\.?ต\.?อ\.?|พล\.?ต\.?ท\.?|พล\.?ต\.?ต\.?|พ\.?ต\.?อ\.?|พ\.?ต\.?ท\.?|พ\.?ต\.?ต\.?|ร\.?ต\.?อ\.?|ร\.?ต\.?ท\.?|ร\.?ต\.?ต\.?|ด\.?ต\.?|จ\.?ส\.?ต\.?|ส\.?ต\.?อ\.?|ส\.?ต\.?ท\.?|ส\.?ต\.?ต\.?|พลฯม\.?ล\.?|ม\.?ร\.?ว\.?)/gi;
    name = name?.toString().toLowerCase().normalize("NFC").replace(/[^a-zA-Z0-9\u0E00-\u0E7F .-]/g, "").replace(/\s+/g, " ").replace(regx, "").replaceAll(".","").trim();
    bank_name = bank_name?.toString().toLowerCase().normalize("NFC").replace(/[^a-zA-Z0-9\u0E00-\u0E7F .-]/g, "").replace(/\s+/g, " ").replace(regx, "").replaceAll(".","").trim();

    // เช็ค Name ว่าเป็น ไทย หรือ อังกฤษ
    let name_lang = "";
    if (/^[ก-๙]/.test(name.trim())) name_lang = "TH";
    if (/^[A-Za-z]/.test(name.trim())) name_lang = "EN";

    // เช็ค Bank Name ว่าเป็น ไทย หรือ อังกฤษ
    let bank_name_lang = "";
    if (/^[ก-๙]/.test(bank_name.trim())) bank_name_lang = "TH";
    if (/^[A-Za-z]/.test(bank_name.trim())) bank_name_lang = "EN";

    let case_result = null;
    // เคส 1
    if (name_lang === "TH" && bank_name_lang === "EN") {
      // ลบตัวที่ 2 (ชื่อกลาง)
      if (bank_name.split(" ").length > 2) {
        bank_name = bank_name
          .split(" ")
          .filter((e, i) => i !== 1)
          .join(" ");
      }
      let result = await checkMismatch(name, bank_name, threshold);
      log(result?.score, name_lang, name, bank_name_lang, bank_name);

      case_result = result;

      if (!result?.isMatch) {
        const nameParts = name.split(" ").filter(Boolean);
        const bankParts = bank_name.split(" ").filter(Boolean);

        const scores = [];

        // ===== cross compare + average =====
        for (const n of nameParts) {
          let bestScore = 0;

          for (const b of bankParts) {
            const r = await checkMismatch(n, b, threshold);
            if (r?.score > bestScore) {
              bestScore = r.score;
            }
          }

          if (bestScore > 0) {
            scores.push(bestScore);
          }
        }

        if (scores.length > 0) {
          const avgScore =
            scores.reduce((sum, s) => sum + s, 0) / scores.length;

          case_result = {
            isMatch: avgScore >= threshold,
            score: avgScore,
            method: "SPLIT_AVERAGE",
          };
        }

        log(
          case_result?.score,
          name_lang,
          nameParts.join(" "),
          bank_name_lang,
          bankParts.join(" ")
        );
      }
    }

    // เคส 2
    if (bank_name_lang === "TH" && name_lang === "EN") {
      // ลบตัวที่ 2 (ชื่อกลาง)
      if (name.split(" ").length > 2) {
        name = name
          .split(" ")
          .filter((e, i) => i !== 1)
          .join(" ");
      }
      let result = await checkMismatch(bank_name, name, threshold);
      log(result?.score, name_lang, name, bank_name_lang, bank_name);

      case_result = result;

      // ===== split + average logic =====
      if (!result?.isMatch) {
        const bankParts = bank_name.split(" ").filter(Boolean);
        const nameParts = name.split(" ").filter(Boolean);

        const scores = [];

        for (const b of bankParts) {
          let bestScore = 0;

          for (const n of nameParts) {
            const r = await checkMismatch(b, n, threshold);
            if (r?.score > bestScore) {
              bestScore = r.score;
            }
          }

          if (bestScore > 0) {
            scores.push(bestScore);
          }
        }

        if (scores.length > 0) {
          const avgScore =
            scores.reduce((sum, s) => sum + s, 0) / scores.length;

          case_result = {
            isMatch: avgScore >= threshold,
            score: avgScore,
            method: "SPLIT_AVERAGE",
          };
        }

        log(
          case_result?.score,
          name_lang,
          nameParts.join(" "),
          bank_name_lang,
          bankParts.join(" ")
        );
      }
    }

    // เคส 3
    if (name_lang === bank_name_lang) {
      // ลบตัวที่ 2 (ชื่อกลาง)
      if (name_lang === "EN") {
        if (name.split(" ").length > 2) {
          name = name
            .split(" ")
            .filter((e, i) => i !== 1)
            .join(" ");
        }
        if (bank_name.split(" ").length > 2) {
          bank_name = bank_name
            .split(" ")
            .filter((e, i) => i !== 1)
            .join(" ");
        }
      }
      if (name.replaceAll(" ", "") === bank_name.replaceAll(" ", "")) {
        // ชื่อตรง 100%
        case_result = { score: 100, isMatch: true };
      } else if (
        name.startsWith(bank_name) ||
        bank_name.startsWith(name) ||
        name.startsWith(bank_name.split(" ").reverse().join(" ")) ||
        bank_name.startsWith(name.split(" ").reverse().join(" "))
      ) {
        // ชื่อขึ้นต้น
        case_result = { score: 100, isMatch: true };
      } else {
        // เช็คค่าเหมือน
        let score = similarity(name, bank_name);
        if (score > threshold) {
          log(score, name_lang, name, bank_name_lang, bank_name);
          case_result = { score: score, isMatch: true };
        } else {
          score = similarity(name, bank_name.split(" ").reverse().join(" "));
          log(score, name_lang, name, bank_name_lang, bank_name);
          case_result = { score: score, isMatch: score > threshold };
        }
      }
    }

    return case_result;
  }

  // -------------------------------------------------------------------------
  // Render helpers (presentation only — Get / CreateUpdate unchanged)
  // -------------------------------------------------------------------------
  openCreate = () => {
    this.setState({
      modal_create: true,
      id: "",
      uid: "",
      broker_id: "",
      sequence: "",
      tier_name: "",
      min_gmv: "",
      rate: "",
      currency: "THB",
      description: "",

      deposit_fee_type: "percentage",
      deposit_fee_value: "",
      deposits_commission_type: "percentage",
      deposits_commission_value: "",

      withdrawal_fee_type: "percentage",
      withdrawal_fee_value: "",
      withdrawal_commission_type: "percentage",
      withdrawal_commission_value: "",
    });
  };
  openUpdate = (t, broker) => {
    this.setState({
      ...t,
      broker_id: broker.value || "",
      min_gmv: Number(t.min_gmv),
      deposit_fee_value: Number(t.deposit_fee_value),
      deposits_commission_value: Number(t.deposits_commission_value),
      withdrawal_fee_value: Number(t.withdrawal_fee_value),
      withdrawal_commission_value: Number(t.withdrawal_commission_value),
      modal_update: true,
    });
  };
  closeModal = () => {
    this.setState({ modal_create: false, modal_update: false });
  };
  unit = (type, currency) => (type === "percentage" ? "%" : currency || "");
  // One rate row of the modal: value input with unit suffix + %/currency toggle.
  renderRate = ({ label, value, type, onValue, onType, currency }) => (
    <div className="mb-3">
      <label className="pr-label">{label}{required}</label>
      <div className="pu-rate">
        <div className="position-relative flex-grow-1">
          <input
            type="text"
            className="form-control pr-input pe-5"
            placeholder="0.00"
            onChange={(e) => {
              if (!float(e.target.value, 4)) return;
              onValue(e.target.value);
            }}
            value={value}
          />
          <span className="pu-input-suffix">{this.unit(type, currency)}</span>
        </div>
        <div className="pu-rate-toggle">
          <button
            type="button"
            className={type === "percentage" ? "active" : ""}
            onClick={() => onType("percentage")}
          >
            %
          </button>
          <button
            type="button"
            className={type === "fixed" ? "active" : ""}
            onClick={() => onType("fixed")}
          >
            {currency || "Fixed"}
          </button>
        </div>
      </div>
    </div>
  );
  renderTierCard = (t, broker) => {
    const flag = global.currency.find((b) => b.currency_code === t.currency)?.image;
    return (
      <div
        key={t.uid || `${broker.value}-${t.sequence}-${t.currency}`}
        className={`pu-tier-card ${t.is_active ? "on" : ""}`}
      >
        <div className="pu-tier-card-top">
          <span className={`pu-tier ${t.is_active ? "" : "off"}`} title={t.tier_name || ""}>
            <img alt={t.sequence || ""} src={RANK_IMAGES[t.sequence] || RANK1} width={22} />
          </span>
          <div className="min-w-0 flex-grow-1">
            <div className="pu-tier-name text-truncate" title={t?.tier_name}>
              {flag}
              <span className="ms-1">{t?.tier_name || "-"}</span>
            </div>
            <div className="pu-sub">
              min GMV <b className="pu-tier-gmv">{toFixed(t?.min_gmv)}</b> {t.currency}
            </div>
          </div>
          <button
            type="button"
            className="ar-row-action tier-configs.update"
            title="Update"
            onClick={() => this.openUpdate(t, broker)}
          >
            <span className="icon">{""}</span>
          </button>
        </div>
        <div className="pu-tier-rates">
          <div className="pu-tier-rate dep">
            <span className="pu-tier-rate-label">
              <i className="ar-legend-dot ar-legend-dep"></i>Deposit
            </span>
            <span>
              fee <b>{toFixed(t?.deposit_fee_value)}{this.unit(t.deposit_fee_type, t.currency)}</b>
              <span className="pu-tier-sep">·</span>
              com <b>{toFixed(t?.deposit_commission_value)}{this.unit(t.deposits_commission_type, t.currency)}</b>
            </span>
          </div>
          <div className="pu-tier-rate wd">
            <span className="pu-tier-rate-label">
              <i className="ar-legend-dot ar-legend-wd"></i>Withdrawal
            </span>
            <span>
              fee <b>{toFixed(t?.withdrawal_fee_value)}{this.unit(t.withdrawal_fee_type, t.currency)}</b>
              <span className="pu-tier-sep">·</span>
              com <b>{toFixed(t?.withdrawal_commission_value)}{this.unit(t.withdrawal_commission_type, t.currency)}</b>
            </span>
          </div>
        </div>
        {t.is_active ? (
          <span className="pu-tier-active">
            <span className="icon me-1">{""}</span>Current tier
          </span>
        ) : null}
      </div>
    );
  };
  render() {
    const {
      modal_create,
      modal_update,
      filter_search,
      data,
      loaded,
      data_broker,
      data_sequence,
      broker_id,
      sequence,
      tier_name,
      min_gmv,
      currency,
      description,

      deposit_fee_type,
      deposit_fee_value,
      deposits_commission_type,
      deposits_commission_value,

      withdrawal_fee_type,
      withdrawal_fee_value,
      withdrawal_commission_type,
      withdrawal_commission_value,
    } = this.state;
    const brokers = Array.isArray(data_broker) ? data_broker : [];
    const tierCount = (data || []).reduce((acc, e) => acc + (e.array?.length || 0), 0);
    const brokersWithTier = (data || []).filter((e) => e.array?.length).length;
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          {/* HERO */}
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Configuration</div>
                <div className="ar-title">Tier Settings</div>
                <div className="ar-subtitle">
                  Configure broker tier requirements, fee and commission rates per
                  currency.
                </div>
              </div>
              <div className="d-flex align-items-end gap-4">
                <div className="pu-hero-legend d-none d-md-flex align-items-center gap-3">
                  <span>
                    <b className="pu-hero-num">{tierCount}</b> tier{tierCount === 1 ? "" : "s"}
                  </span>
                  <span className="ar-divider" />
                  <span>
                    <b className="pu-hero-num">{brokersWithTier}</b> / {brokers.length} broker
                    {brokers.length === 1 ? "" : "s"} configured
                  </span>
                </div>
                <div className="ar-hero-actions">
                <button className="ar-btn-gold tier-configs.create" onClick={this.openCreate}>
                  <span className="icon me-2">{""}</span>Create Tier
                </button>
                </div>
              </div>
            </div>

            <div className="ar-toolbar ar-filter mt-3">
              <div className="ar-filter-head">
                <span className="ar-toolbar-label">
                  <span className="icon me-2">{""}</span>Filter
                </span>
              </div>
              <div className="ar-filter-row">
                <div className="ar-filter-field ar-filter-field-search">
                  <span className="ar-filter-label">Search</span>
              <input
                type="text"
                className="form-control"
                placeholder="Search tier name..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
                </div>
              <div className="ar-toolbar-actions">
              <button className="ar-btn-gold" onClick={() => this.Get(1)}>
                <span className="icon me-2">{""}</span>Search
              </button>
              <button
                className="ar-btn-ghost"
                onClick={() => {
                  this.setState({ filter_search: "" }, () => this.Get(1));
                }}
              >
                Reset
              </button>
              </div>
              </div>
            </div>
          </div>

          {/* MATRIX */}
          <div className="ar-table-card">
            <div className="ar-table-head">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{""}</span>
                  Broker Tiers
                </div>
                <div className="ar-table-caption">
                  {brokers.length} broker{brokers.length === 1 ? "" : "s"} · {data_sequence.length} tier level
                  {data_sequence.length === 1 ? "" : "s"}
                </div>
              </div>
              <div className="d-none d-md-flex align-items-center gap-3 ar-legend">
                <span>
                  <span className="pu-legend-dot on" />
                  Current tier
                </span>
                <span><i className="ar-legend-dot ar-legend-dep"></i>Deposit</span>
                <span><i className="ar-legend-dot ar-legend-wd"></i>Withdrawal</span>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table ar-table pu-table pu-tier-table">
                <thead>
                  <tr>
                    <td className="text-nowrap ar-sticky wpx-200">Broker</td>
                    {data_sequence.map((e, i) => (
                      <td className="text-center text-nowrap" key={`header-tier-${i}`}>
                        <img
                          className="me-2 pu-tier-head-img"
                          alt=""
                          src={RANK_IMAGES[e] || RANK1}
                          width={18}
                        />
                        Tier {e}
                      </td>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {brokers.map((item, index) => {
                    const group = data.find((d) => d.broker_id === item.value);
                    const configured = group?.array?.length || 0;
                    return (
                      <tr key={item.value || `array-${index}`}>
                        <td data-label="Broker" className="text-nowrap align-top ar-sticky">
                          <div className="pu-user">
                            <div className={`pu-avatar ${configured ? "" : "off"}`}>
                              {(item.label || "?").trim().charAt(0).toUpperCase()}
                            </div>
                            <div className="min-w-0">
                              <div className="pu-name text-truncate" title={item.label}>
                                {item.label || "-"}
                              </div>
                              <div className="pu-sub">
                                {configured
                                  ? `${configured} tier${configured === 1 ? "" : "s"}`
                                  : "No tier configured"}
                              </div>
                            </div>
                          </div>
                        </td>
                        {data_sequence.map((e, i) => {
                          const _item = group?.array.filter((d) => d.sequence === e) || [];
                          return (
                            <td
                              key={`cell-${index}-${i}`}
                              className="align-top pu-tier-cell"
                              data-label={`Tier ${e}`}
                            >
                              {_item.length ? (
                                <div className="pu-tier-stack">
                                  {_item.map((t) => this.renderTierCard(t, item))}
                                </div>
                              ) : (
                                <span className="pu-tier-empty">—</span>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                  {loaded && brokers.length === 0 && (
                    <tr>
                      <td colSpan={data_sequence.length + 1} className="p-0 border-0">
                        <div className="pr-empty rounded-0 border-0">
                          <span className="icon">{""}</span>
                          <div className="fw-bold">No broker found</div>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* CREATE UPDATE */}
        <Modal
          show={modal_create || modal_update}
          size="lg"
          dialogClassName="pr-modal pr-scope pu-scope"
          onHide={this.closeModal}
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div className="d-flex align-items-center gap-3">
              <span className="pu-modal-logo">
                <img alt="" src={RANK_IMAGES[Number(sequence)] || RANK1} width={30} />
              </span>
              <div>
                <div className="pr-modal-eyebrow">
                  {modal_create ? "New tier" : "Edit tier"}
                </div>
                <h5 className="fw-bold mb-0">
                  {modal_create ? "Create" : modal_update ? "Update" : ""} Tier
                  {tier_name ? ` · ${tier_name}` : ""}
                </h5>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            {/* BASIC INFORMATION */}
            <div className="pu-section">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Basic Information
              </div>
              <div className="row g-3">
                <div className="col-12 col-md-7">
                  <label className="pr-label">Broker{required}</label>
                  <Select
                    className="form-control pr-input"
                    placeholder="Select broker"
                    options={data_broker}
                    onChange={(e, i) => {
                      this.setState({ broker_id: e });
                    }}
                    value={broker_id}
                    disabled={profile?.user_type === "broker" || modal_update}
                  />
                </div>
                <div className="col-12 col-md-5">
                  <label className="pr-label">Currency</label>
                  <Select
                    className="form-control"
                    placeholder="Currency"
                    options={global.currency?.map((e) => ({
                      label: e.currency_name,
                      value: e.currency_code,
                      front: e.image,
                    }))}
                    onChange={(e, i) => {
                      this.setState({
                        currency: e,
                        customer_id: "",
                      });
                    }}
                    value={currency}
                  />
                </div>
                <div className="col-4 col-md-3">
                  <label className="pr-label">Seq.{required}</label>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="1"
                    onChange={(e) => {
                      if (!float(e.target.value)) return;
                      this.setState({ sequence: e.target.value });
                    }}
                    value={sequence}
                  />
                </div>
                <div className="col-8 col-md-5">
                  <label className="pr-label">Tier Name{required}</label>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="e.g. Gold"
                    onChange={(e) => {
                      this.setState({ tier_name: e.target.value });
                    }}
                    value={tier_name}
                  />
                </div>
                <div className="col-12 col-md-4">
                  <label className="pr-label">Min GMV{required}</label>
                  <div className="position-relative">
                    <NumericFormat
                      thousandSeparator=","
                      decimalScale={2}
                      type="text"
                      className="form-control pr-input pe-5"
                      placeholder="0.00"
                      value={min_gmv}
                      onValueChange={(values) =>
                        this.setState({ min_gmv: values.value })
                      }
                    />
                    <span className="pu-input-suffix">{currency}</span>
                  </div>
                </div>
                <div className="col-12">
                  <label className="pr-label">Description{required}</label>
                  <textarea
                    className="form-control pr-input"
                    placeholder="What this tier offers..."
                    rows={3}
                    onChange={(e) => {
                      this.setState({ description: e.target.value });
                    }}
                    value={description}
                  />
                </div>
              </div>
            </div>

            <div className="row g-3">
              {/* DEPOSIT */}
              <div className="col-12 col-md-6">
                <div className="pu-section pu-section-dep h-100 mb-0">
                  <div className="pu-section-title">
                    <span className="icon">{""}</span>Deposit
                  </div>
                  {this.renderRate({
                    label: "Fee Rate",
                    value: deposit_fee_value,
                    type: deposit_fee_type,
                    currency,
                    onValue: (v) => this.setState({ deposit_fee_value: v }),
                    onType: (v) => this.setState({ deposit_fee_type: v }),
                  })}
                  {this.renderRate({
                    label: "Commission Rate",
                    value: deposits_commission_value,
                    type: deposits_commission_type,
                    currency,
                    onValue: (v) => this.setState({ deposits_commission_value: v }),
                    onType: (v) => this.setState({ deposits_commission_type: v }),
                  })}
                </div>
              </div>
              {/* WITHDRAWAL */}
              <div className="col-12 col-md-6">
                <div className="pu-section pu-section-wd h-100 mb-0">
                  <div className="pu-section-title">
                    <span className="icon">{""}</span>Withdrawal
                  </div>
                  {this.renderRate({
                    label: "Fee Rate",
                    value: withdrawal_fee_value,
                    type: withdrawal_fee_type,
                    currency,
                    onValue: (v) => this.setState({ withdrawal_fee_value: v }),
                    onType: (v) => this.setState({ withdrawal_fee_type: v }),
                  })}
                  {this.renderRate({
                    label: "Commission Rate",
                    value: withdrawal_commission_value,
                    type: withdrawal_commission_type,
                    currency,
                    onValue: (v) => this.setState({ withdrawal_commission_value: v }),
                    onType: (v) => this.setState({ withdrawal_commission_type: v }),
                  })}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className="btn btn-dark px-5 me-1 rounded-pill"
              onClick={() => {
                this.CreateUpdate();
              }}
            >
              Submit
            </button>
            <button
              className="btn btn-outline-dark px-5 ms-1 rounded-pill"
              onClick={this.closeModal}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
